var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    'uik-tab__item': true,
    'active': _vm.active
}},[_vm._t("default"),(_vm.extra != '')?_c('span',{staticClass:"uik-tab__extra"},[_vm._v(" "+_vm._s(_vm.extra)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }